import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import { BinaryToggle } from "./BinaryToggle";
import { SettingsPremiumBadge } from "./SettingsPremiumBadge";
import { FeatureItem } from "./FeatureItem";

export const GameSetupSection = ({state, simple_change, name_input_class, NoEdit, RadiosAndCustom, this_parent, gameStartCalendar, state_invalid_input, inviteEndCalendar, simple_checkbox_change}) => {

    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/cup-frontpage-color-0.svg"/><span className="ad_120_bold pl-2"><T>Name of the game</T></span>
                    <p>
                    <small><T>The name is used for invites and game overview</T></small><br/>
                    </p>
                    <div className="ad_newgame_formgroup pt-2">
                        <div className="input-group">
                            <input
                                name="name"
                                value={state.name}
                                onChange={simple_change}
                                className={name_input_class}
                                type="text"
                            />
                        </div>
                    </div>
                </Col>
            </Row>

            <NoEdit>
                <Row className="justify-content-center">
                    <Col md="12" className="px-md-4 pt-4">
                        <img alt="" className="ad_logo_list" src="/gfx/calendar-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game start</T></span>
                        <p>
                        <small><T>When the game starts</T></small><br/>
                        </p>
                        <T><RadiosAndCustom
                            name="gamestartcustom"
                            parent={this_parent}
                            no_custom={true}
                            defaults={[
                                {"value": "0", "text": "Start game now"},
                                {"value": "1", "text": "Choose a start date"},
                            ]}
                        /></T>
                    </Col>
                </Row>
                {gameStartCalendar}
            </NoEdit>

            <NoEdit>
                <Row className="justify-content-center">
                    <Col md="12" className="px-md-4 pt-4">
                        <img alt="" className="ad_logo_list" src="/gfx/game-time-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game time</T></span>
                        <p>
                            <small><T>For how long will the game run</T></small><br/>
                            <small><T>Free plan: up to 30 days. Premium required for longer games.</T></small>
                        </p>
                        <T><RadiosAndCustom
                            name="gametime"
                            parent={this_parent}
                            defaults={[
                                {"value": 30, "text": "30 days"},
                                {"value": 90, "text": "90 days (Premium)"},
                            ]}
                            custom_text="Other (max 365) (Premium)"
                            custom_placeholder="days"
                            custom_error={state_invalid_input === "gametime"}
                            min={1}
                            max={365}
                        /></T>
                    </Col>
                </Row>
            </NoEdit>

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4 new_game_premium px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/calendar-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game Registration Closes</T></span><SettingsPremiumBadge />
                    <p>
                    <small><T>The date when registration for the game closes</T></small><br/>
                    </p>
                    <T><RadiosAndCustom
                        name="inviteendcustom"
                        parent={this_parent}
                        no_custom={true}
                        is_premium_feature={true}
                        defaults={[
                            { "value": "0", "text": "None" },
                            {"value": "1", "text": "Select registration closing date"},
                        ]}
                    /></T>
                </Col>
            </Row>
            {inviteEndCalendar}

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/calendar-color-0.svg" /><span className="ad_120_bold pl-2"><T>Manage your participants</T></span> <SettingsPremiumBadge />
                    <p>
                        <small><T>As a premium user, you also have the option to:</T></small><br/>
                    </p>
                    <FeatureItem text={<T>Remove players from your match</T>} />
                    <FeatureItem text={<T>Add or deduct capital as rewards or penalties</T>} />
                </Col>
            </Row>
            
            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4 pb-4">
                    <img alt="" className="ad_logo_list" src="/gfx/bankroll-icon-color-0.svg" />
                        <span className="ad_120_bold pl-2"><T>Give participants insight into each other's investments</T></span><SettingsPremiumBadge />
                            <p>
                                <small><T>Activate this feature to let participants see how much each person has invested in their assets. Perfect for teaching and group reflection.</T></small><br/>
                            </p>
                        <div className="text-left">
                                <BinaryToggle
                                    name="use_portfolio_info"
                                    checked={state.use_portfolio_info}
                                    onChange={simple_checkbox_change}
                                    labels={[<T>Activate</T>, <T>Deactivate</T>]}
                                />
                        </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/c/GameSetupSection.js